module.exports = __webpack_public_path__ + "img/google.2325f249.png";